"use client";

import { HeaderSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedHeaderSection from "../Components/GeneratedHeaderSection";
import "./Header.css";

const Header: FC<HeaderSectionProps> = (props) => {
  return <GeneratedHeaderSection {...props} />;
};

export default Header;
